import { CoverageLevel } from '@seddi/ui-babylon-fitroom';
import React, { FC, useCallback, useMemo, useState } from 'react';
import { useSelector, useStore } from 'react-redux';
import { CoverageButtonT2, CoveragePopup, CoveragePopupLevelProps } from 'ui';
import { CoverageArea } from '../../avatars';
import { getStyleAvatarCoverage } from '../../garments';
import { updateAvatarDisplay } from '../actions/homeAvatarDisplay';
import { HomeState } from '../store/homeState';
import * as S from './homeSkin.styles';
import { homeStateExt } from '../store/homeStateExt';

const useCoverage = () => {
  const { dispatch } = useStore<HomeState>();

  const ctxCoverageBottom = useSelector((state: HomeState) => state.avatarDisplayCovBottom);
  const ctxCoverageTop = useSelector((state: HomeState) => state.avatarDisplayCovTop);
  const ctxStyle = useSelector((state: HomeState) => state.style);

  const [bottom, top] = useMemo(() => {
    // Coverage status.
    const bottom: CoveragePopupLevelProps = { selection: ctxCoverageBottom };
    const top: CoveragePopupLevelProps = { selection: ctxCoverageTop };

    // Coverage status from style.
    if (ctxStyle?.id) {
      const style = homeStateExt.style!;
      const styleCoverage = getStyleAvatarCoverage(style);
      bottom.isDisabled = styleCoverage.isBottomDisabled;
      top.isDisabled = styleCoverage.isTopDisabled;
    }

    return [bottom, top];
  }, [ctxCoverageBottom, ctxCoverageTop, ctxStyle]);

  // Selection state
  const [isSelected, setSelected] = useState<boolean>(false);

  const setCoverage = useCallback(
    (area: CoverageArea, level: CoverageLevel) => {
      switch (area) {
        case CoverageArea.BOTTOM:
          updateAvatarDisplay(dispatch, { coverageBottom: level });
          break;
        case CoverageArea.TOP:
          updateAvatarDisplay(dispatch, { coverageTop: level });
          break;
      }
    },
    [dispatch],
  );

  return {
    bottom,
    isSelected,
    top,
    setCoverage,
    setSelected,
  };
};

export const HomeCoverage: FC = () => {
  const { bottom, isSelected, top, setCoverage, setSelected } = useCoverage();

  const onChange = useCallback(
    (area: CoverageArea, level: CoverageLevel) => {
      setCoverage(area, level);
    },
    [setCoverage],
  );

  const onClick = useCallback(() => {
    setSelected(!isSelected);
  }, [isSelected, setSelected]);

  return (
    <S.Layout>
      {isSelected && <CoveragePopup bottom={bottom} top={top} onChange={onChange} />}
      <CoverageButtonT2 isSelected={isSelected} onClick={onClick} />
    </S.Layout>
  );
};
